import styled from 'styled-components'

export const ProfilesWrapper = styled.span`
  color: #0085ff;
  font-weight: 700;
  cursor: pointer;
  transition: 200ms;
  svg {
    margin-left: 8px;
  }
`
